<template>
  <div class="truck flex-v-center">
    <div class="truck__picture flex-center">
      <img src="@/assets/img/new-person.svg" alt="truck ">
    </div>
    <div class="truck__info">
      <div class="font-normal">Водитель</div>
      <div class="truck__info-title">{{ driver.fio }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverItem',
  props: {
    driver: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.truck
  margin-bottom: 1.2rem
  padding: 1.6rem
  border: 1px solid #EDEDED
  border-radius: 1.2rem

  &__picture
    width: 4.6rem
    height: 4.6rem
    margin-right: 1.6rem
    background: #EBF9EB
    border-radius: .8rem
    img
      width: 2.4rem
      height: 2.4rem
  &__info
    &-title
      margin-top: 0.4rem
      font-size: 1.6rem
      line-height: 2rem
      font-weight: 700
      color: #181818
</style>
